import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController, ToastController } from '@ionic/angular';
import { GpCallMetaModel, GpCallModel } from 'gp-asterisk';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { OrdersService } from 'shared';
import { CallDirectorySyncService } from '../call-directory/call-directory-sync.service';

addIcons({ closeOutline });

@Component({
  selector: 'mobile-call-order-modal',
  templateUrl: './call-order-modal.component.html',
  styleUrls: ['./call-order-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, ReactiveFormsModule, AsyncPipe],
  providers: [OrdersService]
})
export class CallOrderModalComponent implements OnInit {
  @Input({ required: true }) call: GpCallModel | GpCallMetaModel;

  readonly loading$ = new BehaviorSubject(false);

  readonly form = new FormGroup({
    reason: new FormControl('', [Validators.required]),
    street: new FormControl(''),
    city: new FormControl('')
  });

  constructor(
    private modalController: ModalController,
    private ordersService: OrdersService,
    private toastController: ToastController,
    private callDirectorySyncService: CallDirectorySyncService
  ) {}

  ngOnInit() {
    const meta = this.call as GpCallMetaModel;
    if (meta?.street) this.form.controls.street.setValue(meta.street);
    if (meta?.city) this.form.controls.city.setValue(meta.city);
  }

  get callerName(): string {
    const meta = this.call as GpCallMetaModel;
    return meta?.client?.name || this.call.nameCaller || null;
  }

  dismiss() {
    this.modalController.dismiss();
  }

  create() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading$.next(true);

    this.ordersService.getNextMetaData().subscribe({
      next: (meta) => {
        const meta2 = this.call as GpCallMetaModel;
        this.ordersService.createOrder({
          id: meta.nextId,
          docNumber: meta.nextNumber,
          createdAt: DateTime.now().toISO(),
          version: 1,
          isNew: true,
          reason: this.form.value.reason,
          comment: '',
          street: this.form.value.street || '',
          city: this.form.value.city || '',
          country: '',
          lat: null,
          lng: null,
          issuedAt: null,
          doneAt: null,
          status: null,
          typeServiceId: null,
          client: {
            id: meta2?.client?.id || null,
            name: meta2?.client?.name || null,
            phone: this.call.phone,
            phone2: meta2?.client?.phone2 || null,
            isToxic: meta2?.client?.isToxic || false,
            debts: meta2?.client?.debts || []
          }
        } as any).subscribe({
          next: async () => {
            this.loading$.next(false);
            const toast = await this.toastController.create({
              message: 'Заявку створено',
              duration: 2000,
              color: 'success',
              position: 'bottom'
            });
            await toast.present();
            this.callDirectorySyncService.sync().subscribe();
            this.modalController.dismiss({ created: true });
          },
          error: async () => {
            this.loading$.next(false);
            const toast = await this.toastController.create({
              message: 'Помилка при створенні заявки',
              duration: 2000,
              color: 'danger',
              position: 'bottom'
            });
            await toast.present();
          }
        });
      },
      error: () => this.loading$.next(false)
    });
  }
}
